export const DegreesDiscover = [
  {
    title: 'Licenciatura en Derecho Digital (LEDD)',
    description:
      'Formar profesionistas líderes en el campo del Derecho que afronten y solucionen problemas legales y jurídicos derivados de la continua transformación digital del país.',
    users: 300,
    img: 'https://d1g6c01s9ssd7h.cloudfront.net/img/LicDerechoDigital.jpg',
    link: 'LEDD'
  },
  {
    title: 'Licenciatura en Psicología Jurídica Forense (LPJF)',
    description:
      'Impulsando la relación entre la psicología y el derecho basada en evidencia, para la construcción de sociedades más justas',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LPJF_academia.jpg',
    link: 'LPJF'
  },
  {
    title: 'Licenciatura en Artes Escénicas (LAE)',
    description:
      'Una nueva generación de líderes artísticos en escena',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LAE_academia.jpg',
    link: 'LAE'
  }
];

export const Degrees = [
  {
    title: 'Licenciatura en Derecho Digital (LEDD)',
    description:
      'Formar profesionistas líderes en el campo del Derecho que afronten y solucionen problemas legales y jurídicos derivados de la continua transformación digital del país.',
    users: 300,
    img: 'https://d1g6c01s9ssd7h.cloudfront.net/img/LicDerechoDigital.jpg',
    link: 'LEDD'
  },
  {
    title: 'Licenciatura en Psicología Jurídica Forense (LPJF)',
    description:
      'Impulsando la relación entre la psicología y el derecho basada en evidencia, para la construcción de sociedades más justas',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LPJF_academia.jpg',
    link: 'LPJF'
  },
  {
    title: 'Licenciatura en Artes Escénicas (LAE)',
    description:
      'Una nueva generación de líderes artísticos en escena',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LAE_academia.jpg',
    link: 'LAE'
  },
  {
    title: 'Licenciatura en Derecho UAQ (LD)',
    description:
      'Formación de vanguardia para los abogados que necesita el México contemporáneo',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LD_academia.jpg',
    link: 'LD'
  },
  {
    title: 'Licenciatura en Psicología Clínica UAQ (LPC)',
    description: 'Salud mental al servicio de la comunidad',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LPC_academia.jpg',
    link: 'LPC'
  }
];
